<template>
  <div class="flex flex-row justify-between max-w-full overflow-hidden ">
    <div>
      <div class="inline-flex">
        <div v-if="!isMobile">
          <!-- <div v-if="!logos?.wLogo" class="flex shrink-0 grow-0 py-3">
            <NuxtLink to="/" @click="onLogoClick">
              <img :src="defaultData?.logos?.wLogo" class="h-11 w-11" />
            </NuxtLink>
          </div> -->
          <div class="flex shrink-0 grow-0 py-3">
            <NuxtLink to="/" @click="onLogoClick">
              <img :src="logos?.wLogo ? logos?.wLogo : defaultData?.logos?.wLogo" alt="Website logo" title="Go to homepage" class="h-11 w-11" />
            </NuxtLink>
          </div>
        </div>
        <div v-if="isMobile">
          <div class="flex shrink-0 grow-0 py-3">
            <NuxtLink to="/" @click="onLogoClick">
              <img :src="logos?.mLogo ? logos?.mLogo : defaultData?.logos?.mLogo" alt="Mobile logo" title="Go to homepage" class="h-11 w-11" />
            </NuxtLink>
          </div>
          <!-- <div v-if="!logos?.mLogo" class="flex shrink-0 grow-0 py-3">
            <NuxtLink to="/" @click="onLogoClick">
              <img :src="defaultData?.logos?.mLogo" class="h-11 w-11" />
            </NuxtLink>
          </div> -->
        </div>
        <div class="flex shrink px-2" v-if="!isCartpage">
          <V2LocationComponent />
        </div>
      </div>
    </div>
    <div v-if='showSearch' class="w-full md:w-96 mt-4 relative">
      <div class="overflow-hidden rounded-md w-full">
        <V2SearchComponent :placeholder="categories" />
      </div>
    </div>

    <div class="inline-flex items-end justify-end">
      <div class="hidden sm:block h-full">
        <div class="pr-2 cursor-pointer mt-1">
          <div class="flex justify-between">
            <div v-for="item in navIcons.topNavIcons" :key="item.name"
              @click="handleTopNavigationClick(item.name, item.label)"
              class="relative w-[72px] flex flex-col items-center px-1 cursor-pointer rounded-xl"
              :class="{ '': isActiveTopNavItem(item) }"
              :style="{ 'background-color': isActiveTopNavItem(item) ? activeBgColor : '' }">
              <div class="flex items-center justify-center mt-2">
                <img :src="isActiveTopNavItem(item) ? item.activeIcon : item.icon" :alt="item.label + ' icon'" :title="item.label" class="w-6 h-6" />
              </div>
              <div
                class="w-[72px] text-ellipsis overflow-hidden whitespace-nowrap text-center text-xs leading-5 text-navyPrime"
                :class="{ 'font-bold': isActiveTopNavItem(item), 'text-white': partnerId?.toLowerCase() === 'oneindiamall' }">
                {{ item.label }}
              </div>
              <!-- cart icon's item count badge -->
              <!-- <div class="absolute bottom-0 w-full h-1.5 bg-orange-500 rounded-t-lg" v-if="isActiveTopNavItem(item)">
              </div> -->
              <span v-if="(item.name === '/cart' || item.name === '/collections/gift-cards/cart') && item.badge > 0"
                class="absolute top-1 right-3 bg-[#D00B0B] text-white text-xs leading-2 rounded-full h-4 w-4 flex items-center justify-center">
                {{ item.badge }}
              </span>
            </div>
            <div class="px-1 h-14 border-r-2 border-gray-200"></div>
          </div>
        </div>
      </div>
      <div v-if="reward.enabled" class="flex flex-col items-center w-14 mb-2.5 gap-0.5">
        <UIcon name="i-fluent-wallet-credit-card-16-regular" class="text-primeval-700 h-7 w-7 mx-auto" />
        <span class="text-xs font-bold text-navyPrime">{{ reward.rewardPoints }}</span>
      </div>
      <div class="pl-2">
        <!-- mobile view -->
        <div class="relative inline-flex items-center justify-center flex-shrink-0 sm:hidden mb-2.5"
          @click="showQuickMenu">
          <div class="flex flex-col items-center pr-4 grow-0 shrink-0">
            <!-- <img v-if="!profileLogos?.mProfileLogo" loading="lazy" class="w-6 h-6"
              :src="defaultData?.profileLogos?.mProfileLogo" /> -->
            <img loading="lazy" class="w-6 h-6"
              :src="partnerId.toLowerCase() === 'fintastics' ? '/v2/images/orders.webp' : (profileLogos?.mProfileLogo ? profileLogos?.mProfileLogo : defaultData?.profileLogos?.mProfileLogo)"
              alt="Profile icon"
              title="Profile"
            />
            <span class="text-xs mt-0.5" :class="[partnerId?.toLowerCase() === 'oneindiamall' ? 'text-white' : 'dark:text-black']">{{ partnerId.toLowerCase() === 'fintastics' ? 'My Orders' : 'Profile' }}</span>
          </div>
          <span v-if="authToken ? true : false"
            class="absolute rounded-full ring-1 ring-white dark:ring-gray-900 flex items-center justify-center text-white dark:text-gray-900 font-medium whitespace-nowrap h-2 min-w-[0.5rem] text-[7px] p-0.5 top-0 right-5 bg-green-500 dark:bg-green-400"></span>
        </div>
        <!-- web view -->
        <div class="relative inline-flex items-center justify-center flex-shrink-0 hidden sm:block pb-2"
          @click="showQuickMenu">
          <div class="flex flex-col items-center grow-0 shrink-0">
            <!-- <img v-if="!profileLogos?.wProfileLogo" loading="lazy" class="w-6 h-6"
              :src="defaultData?.profileLogos?.wProfileLogo" /> -->
            <img loading="lazy" class="w-6 h-6"
              :src="partnerId.toLowerCase() === 'fintastics' ? '/v2/images/orders.webp' : (profileLogos?.wProfileLogo ? profileLogos?.wProfileLogo : defaultData?.profileLogos?.wProfileLogo)"
              alt="Profile icon"
              title="Profile"
            />
            <p class="text-xs leading-5" :class="[partnerId?.toLowerCase() === 'oneindiamall' ? 'text-white' : 'text-navyPrime dark:text-black']">
              {{ partnerId.toLowerCase() === 'fintastics' ? 'My Orders' : 'Profile' }}
            </p>
          </div>
          <span v-if="authToken ? true : false"
            class="absolute rounded-full ring-1 ring-white dark:ring-gray-900 flex items-center justify-center text-white dark:text-gray-900 font-medium whitespace-nowrap h-2 min-w-[0.5rem] text-[7px] p-0.5 top-0 right-1 bg-green-500 dark:bg-green-400"></span>
          <V2Overlay v-model="isPopupOpen" container-class='pt-6 pr-4 pl-4 pb-1 md:pb-6'>
            <V2LoginComponent @close="closeOverlay" />
          </V2Overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { V3PopupComponent } from "#components";
import { V3ModalComponent } from "#components";
import { popupBackHandler } from "@/composables/popupBackHandler";
import { GoogleAnalytics } from "~/google_analytics/events";
import { EventParameterValue, EventParameter, EventCTANames } from "~/google_analytics/events.enum";
import { setPostAuthRedirect } from '~/utility/authRedirect';

const navIcons = useNavIcons();
const { gtag } = useGtag();
const pageName = ref("")
const activeBgColor = ref("")
const logos = ref({});
const profileLogos = ref({});
let defaultData = {
  logos: {},
  profileLogos: {}
};
const auth = useAuth();
const reward = useReward();
const runtimeConfig = useRuntimeConfig();
const partnerId = runtimeConfig.public.partnerCode;
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  }
  : {
    user_name: null,
    user_phone: null,
    user_email: null,
  };

const props = defineProps({
  title: { type: String, default: "" },
  cart: { type: Boolean, default: true },
  homeNavigation: { type: Boolean, default: false },
  nativeAppNavigation: { type: Boolean, default: false },
  textColor: { type: String, default: "text-black" },
});
const cartCount = computed(() => useCart().itemCount);

const closeOverlay = () => {
  isPopupOpen.value = false;
};

const giftCartCount = computed(() => useGiftCart().itemCount);

const { getTrackingContext } = useTracking();
const trackingContext = getTrackingContext();
const route = useRoute();
const isHomepage = computed(() => route.name === "index");
const router = useRouter();
const handleNavigateToBack = () => {
  props.nativeAppNavigation
    ? handleNavigateToApp()
    : props.homeNavigation
      ? navigateTo({ path: "/" })
      : router.back();
};
const handleNavigateToApp = () => {
  try {
    if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      window.pwa.postMessage();
    } else if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
      window.webkit.messageHandlers.pwa.postMessage();
    } else {
      console.log("App navigation not supported by browser!");
    }
  } catch (error) {
    console.error(error.message); ``
  }
};

const { isMobile, isDesktop } = useDevice();
const slideover = useSlideover();
const modal = useModal();
const authToken = computed(() => auth.access_token);
const { isPopupOpen, openPopup, closePopup } = popupBackHandler();
const analyticsEvents = useAnalyticsEvents();
const isCartpage = computed(() => route.path === '/cart');

const hideSearchPatterns = [
  '/categories/search-v2',
  '/categories',
  '/shop', // will match all routes starting with /shop
  '/cart',
  '/coupons',
  '/collections/giftcards',
  '/collections/gift-cards',
  'collections/gift-cards/cart',
  '/account/orders',
  '/search',
  '/v2/search',
  '/filter/v2'
];

const showSearch = computed(() => {
  if (!isDesktop) return false;

  // check if the current route matches any hide pattern
  return !hideSearchPatterns.some(pattern => route.path.startsWith(pattern))&& partnerId.toLowerCase() !== 'fintastics';
});

const showQuickMenu = () => {
  useAnalytics(analyticsEvents.NAV_BAR_CLICK, {
    cta_text: 'Profile',
    placement: 'header',
  });
  
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: EventCTANames.PROFILE_CTA,
    [EventParameter.PLACEMENT]: EventParameterValue.HEADER,
  });
  
  if (!auth.access_token) {
    setPostAuthRedirect({ path: partnerId.toLowerCase() === 'fintastics' ? '/account/orders' : '/account/profile' });    isPopupOpen.value = true;
    return;
  }
  return navigateTo({ path: partnerId.toLowerCase() === 'fintastics' ? '/account/orders' : '/account/profile' });
};

const { data: categoryResult } = await useAPIHandler("get", "/categories");
const categories = categoryResult.categories
  .filter((k) => k.displayName !== "Appliances")
  .map((k) => k.displayName)
  .sort((a, b) => a.localeCompare(b));

const showHomepage = async () => {
  useAnalytics(analyticsEvents.NAV_BAR_CLICK, {
    cta_text: 'Logo',
    placement: 'header',
  });
  
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: EventCTANames.HEADER_HOME_ICON,
    [EventParameter.PLACEMENT]: EventParameterValue.HEADER,
  });
  await navigateTo({ path: "/" });
};

const onLogoClick = async () => {
  console.log("Logo clicked");
  useAnalytics(analyticsEvents.NAV_BAR_CLICK, {
    cta_text: 'Logo',
    placement: 'header',
  });
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: EventCTANames.HEADER_LOGO,
    [EventParameter.PLACEMENT]: EventParameterValue.HEADER,
  });
};

const navCart = async () => {
  const giftCart = useGiftCart();
  if (giftCart.itemCount > 0) {
    await navigateTo({ path: "/collections/gift-cards/cart" });
  } else {
    await navigateTo({ path: "/cart" });
  }
};
const location = useLocation();
const isLocationAvailable = computed(() => location.isGPSEnabled);
const handleNavigateToCart = async () => {

    GoogleAnalytics.cta({
      [EventParameter.CTA_NAME]: 'header_cart_icon',
      [EventParameter.PLACEMENT]: EventParameterValue.HEADER,
    });

  if (!isLocationAvailable.value && isAuthenticated && route.path !== '/loans') {
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: "location",
        closable: false,
        onSuccess: () => navCart(),
        onClose: slideover.close,
      });
    } else {
      modal.open(V3ModalComponent, {
        component: "location",
        closable: false,
        onSuccess: () => navCart(),
        onClose: modal.close,
      });
    }
    return;
  } else {
    await navCart();
  }
};

onMounted(() => {
  if (route.path.toLowerCase() === "/" || route.path.toLowerCase() === "/homepagev2") {
    pageName.value = "homepage"
  } else if (route.path.toLowerCase() === "/deals") {
    pageName.value = "allDeals"
  } else if (route.path.toLowerCase() === "/categories/v2") {
    pageName.value = "allCategories"
  } else if (route.path.toLowerCase() === "/categories" && route.query.parent) {
    pageName.value = route.query.parent
  } else if (route.path.toLowerCase().startsWith("/shop") && route.params.id) {
    pageName.value = route.params.id
  } else if (route.path.toLowerCase() === "/collections/giftcards") {
    pageName.value = "giftcards"
  } else if (route.path === "/collections/festiveSales") {
    pageName.value = "fclp"
  } else if (route.path.toLowerCase().startsWith("/collections/fs") && route.params.id) {
    pageName.value = route.params.id
  }

  getPartner()
  navIcons.getTopNavIcons(pageName.value);
});

const getPartner = async () => {
  const { data: partner } = await useAPIHandler("get", "/partners", {
    query: { id: partnerId },
  });
  let data = {}
  if (route.path.toLowerCase() === "/" || route.path.toLowerCase() === "/homepagev2") {
    Object.assign(data, partner.cmsV2.navbarConfig["homepage"]);
  } else if (route.path.toLowerCase() === "/deals") {
    Object.assign(data, partner.cmsV2.navbarConfig["deals"]["allDeals"]);
  } else if (route.path.toLowerCase() === "/categories/v2") {
    Object.assign(data, partner.cmsV2.navbarConfig["allCategories"]);
  } else if (route.path.toLowerCase() === "/categories" && route.query.parent) {
    Object.assign(data, partner.cmsV2.navbarConfig["categories"][route.query.parent]);
  } else if (route.path.toLowerCase().startsWith("/shop") && route.params.id) {
    Object.assign(data, partner.cmsV2.navbarConfig["categories"][route.params.id]);
  } else if (route.path.toLowerCase() === "/collections/giftcards") {
    Object.assign(data, partner.cmsV2.navbarConfig["categories"]["giftcards"]);
  } else if (route.path === "/collections/festiveSales") {
    Object.assign(data, partner.cmsV2.navbarConfig["categories"]["fclp"]);
  } else if (route.path.toLowerCase().startsWith("/collections/fs") && route.params.id) {
    Object.assign(data, partner.cmsV2.navbarConfig["categories"][route.params.id]);
  }
  
  logos.value = data.logo;
  profileLogos.value = data.profileLogo;
  defaultData.logos = partner.cmsV2.navbarConfig["default"].logo;
  defaultData.profileLogos = partner.cmsV2.navbarConfig["default"].profileLogo;
  activeBgColor.value = data.
    activeIconBgColor ? data.
    activeIconBgColor : partner.cmsV2.navbarConfig["default"].
    activeIconBgColor;
};

const isActiveTopNavItem = (item) => {
  return route.path === item.name;
};
const handleTopNavigationClick = async (routeName, itemLabel) => {
  useAnalytics(analyticsEvents.NAV_BAR_CLICK, {
    cta_text: itemLabel,
    placement: 'header',
  });
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: `${itemLabel.toLowerCase()}_cta`,
    [EventParameter.PLACEMENT]: EventParameterValue.HEADER,
  });
  if (itemLabel === "My Orders" || itemLabel.toLowerCase() === "airportzo") {
    if (!authToken.value) {
      setPostAuthRedirect({path: routeName, });
      isPopupOpen.value = true;
      return;
    }
    await navigateTo({ path: routeName });
    return;
  }
  let routes = [
    "/account/orders",
    // "/cart",
    "/menu",
    "/select-location",
    "/account/tickets",
    "/account/profile",
    "/support/raise_a_request",
  ];
  if (isAuthenticated == null && routes.includes(routeName)) {
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: "login",
        closable: true,
        onSuccess: () => {
          useSSOAuth(routeName);
        },
        onClose: slideover.close,
      });
    } else {
      modal.open(V3ModalComponent, {
        component: "login",
        closable: true,
        onSuccess: () => {
          useSSOAuth(routeName);
        },
        onClose: modal.close,
      });
    }
    return;
  } else {
    await navigateTo({ path: routeName });
  }
};

watch(isPopupOpen, (newVal) => {
  if (!newVal) {
    slideover.close();
    modal.close();
  }
});
</script>
